// store/reducers/ReceptionistAppointmentReducer.js
import {
    GET_BOOKED_APPOINTMENTS_REQUEST,
    GET_BOOKED_APPOINTMENTS_SUCCESS,
    GET_BOOKED_APPOINTMENTS_FAILURE,
 
  } from "../types/AppoinmentTypes";
  
  const initialState = {
    // Booked appointments
    bookedAppointments: [],
    loading: false,
    error: null,
    
    // Available slots
  
  };
  
  export const AppoinmentReducer = (state = initialState, action) => {
    switch (action.type) {
      // Get Booked Appointments
      case GET_BOOKED_APPOINTMENTS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null
        };
        
      case GET_BOOKED_APPOINTMENTS_SUCCESS:
        return {
          ...state,
          loading: false,
          bookedAppointments: action.payload,
          error: null
        };
        
      case GET_BOOKED_APPOINTMENTS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      

      

      
      default:
        return state;
    }
  };